require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/fn/symbol/iterator.js
// module id = 617
// module chunks = 0